import { render, staticRenderFns } from "./news_school_detail.vue?vue&type=template&id=04925b8a&"
import script from "./news_school_detail.vue?vue&type=script&lang=js&"
export * from "./news_school_detail.vue?vue&type=script&lang=js&"
import style0 from "./news_school_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports